function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import styled from 'styled-components';
import { showPopup } from 'oskari-ui/components/window';
import { Message, Alert } from 'oskari-ui';
import { LocaleProvider } from 'oskari-ui/util';
import { UserStyleEditor } from './UserStyles/UserStyleEditor';
import { UserStylesContent } from './UserStyles/UserStylesContent';
import { BUNDLE_KEY } from '../constants';
import { VECTOR_STYLE } from '../../mapmodule/domain/constants';
var Content = styled.div.withConfig({
  displayName: "view__Content",
  componentId: "sc-dzy0fj-0"
})(["padding:24px;width:500px;"]);
var Info = styled(Alert).withConfig({
  displayName: "view__Info",
  componentId: "sc-dzy0fj-1"
})(["margin-bottom:24px;"]);
var getContent = function getContent(service, options, onClose) {
  var layerId = options.layerId,
    id = options.id,
    showEditor = options.showEditor,
    geometryType = options.geometryType;
  var content;
  if (showEditor) {
    var wasEditor = true;
    var style = service.getStyleById(id) || {};
    var onAdd = function onAdd(_ref) {
      var name = _ref.name,
        featureStyle = _ref.featureStyle;
      service.saveUserStyle({
        id: id,
        layerId: style.layerId || layerId,
        type: VECTOR_STYLE.OSKARI,
        name: name,
        style: {
          featureStyle: featureStyle
        }
      });
      onClose(wasEditor);
    };
    content = /*#__PURE__*/React.createElement(UserStyleEditor, {
      style: style,
      onAdd: onAdd,
      geometryType: geometryType,
      onCancel: function onCancel() {
        return onClose(wasEditor);
      }
    });
  } else {
    var styles = service.getStylesByLayer(layerId);
    var onDelete = function onDelete(id) {
      return service.removeUserStyle(id);
    };
    content = /*#__PURE__*/React.createElement(UserStylesContent, {
      layerId: layerId,
      styles: styles,
      onDelete: onDelete
    });
  }
  var isGuest = !Oskari.user().isLoggedIn();
  return /*#__PURE__*/React.createElement(LocaleProvider, {
    value: {
      bundleKey: BUNDLE_KEY
    }
  }, /*#__PURE__*/React.createElement(Content, null, isGuest && /*#__PURE__*/React.createElement(Info, {
    showIcon: true,
    type: "warning",
    message: /*#__PURE__*/React.createElement(Message, {
      bundleKey: BUNDLE_KEY,
      messageKey: 'runtime'
    })
  }), content));
};
var getTitle = function getTitle(options) {
  var messageKey = options.showEditor ? 'popup.title' : 'title';
  return /*#__PURE__*/React.createElement(Message, {
    bundleKey: BUNDLE_KEY,
    messageKey: messageKey
  });
};
export var showStylesPopup = function showStylesPopup(service) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var onClose = arguments.length > 2 ? arguments[2] : undefined;
  var controls = showPopup(getTitle(options), getContent(service, options, onClose), onClose, {
    id: BUNDLE_KEY
  });
  return _objectSpread(_objectSpread({}, controls), {}, {
    update: function update(options) {
      controls.update(getTitle(options), getContent(service, options, onClose));
    }
  });
};